module.exports = __webpack_public_path__ + "assets/img/b919-ng.svg";